document.addEventListener("DOMContentLoaded", () => {
  var swiper = new Swiper(".featured-slider", {
    slidesPerView: 2,
    spaceBetween: 18,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    lazy: true,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      750: {
        slidesPerView: 3,
        spaceBetween: 20,
        loop: true
      }
    }
  });
});
